import { faker } from '@faker-js/faker';
import type {
  DeploymentRequestResourceReadBffV2Api,
  DeploymentUnitResourceListResponseV2Api,
  GetDeploymentRequestByIdBffV2QueryResponseApi,
} from '@ingenico/api-sdk-device-management-private-v2';
import { HttpResponse } from 'msw';
import { generateErrorWithPlaceholdersApi } from './bff';

const DEPLOYMENT_PLACEHOLDERS_KEYS = [
  'appVersionId',
  'charCount',
  'endDate',
  'fieldId',
  'fieldName',
  'format',
  'max',
  'maxLength',
  'min',
  'minLength',
  'minRows',
  'osVersionId',
  'pattern',
  'refFieldLabel',
  'refFieldName',
  'rowCount',
  'rowNumbe',
  'slartFieldName',
  'smartFieldId',
  'smartFieldName',
  'spVersionId',
  'startDate',
  'templateFileName',
  'value',
];

export function getDeploymentRequestByIdBffV2ErrorMock() {
  return HttpResponse.json(
    generateErrorWithPlaceholdersApi({
      type: 'DPB-ERR-012',
      placeholders: DEPLOYMENT_PLACEHOLDERS_KEYS.map((el) => {
        return {
          key: el,
          value: `${el}Value`,
        };
      }),
    }),

    { status: 404 },
  );
}
export function generateDeploymentRequestResourceReadBffV2(): DeploymentRequestResourceReadBffV2Api {
  return {
    creationDate: faker.date.past(),
    id: faker.string.uuid(),
    name: faker.commerce.product(),
    creator: {
      id: faker.string.uuid(),
      name: faker.commerce.product(),
      type: 'USER',
    },
    dynamicGroup: {
      deviceCount: faker.number.int(),
      snapshotId: faker.string.uuid(),
      type: 'CUSTOM',
    },
    options: {
      // configuration: {
      //   snapshotId: faker.string.uuid(),
      //   type: 'CUSTOM',
      // },
      delete: {
        applicationVersionsIds: [],
        filePaths: [],
        packageIds: [],
        systemPackageVersionsIds: [],
      },
    },
    status: 'FAILED',
    trigger: {
      type: 'AUTOMATIC',
    },
    startDate: faker.date.past(),
  };
}

export function getDeploymentRequestByIdBffV2ResponseMock(): GetDeploymentRequestByIdBffV2QueryResponseApi {
  return generateDeploymentRequestResourceReadBffV2();
}
// eslint-disable-next-line max-lines-per-function
export function getDeploymentRequestById(): DeploymentRequestResourceReadBffV2Api {
  return {
    description: 'Suus demergo voluntarius accommodo bestia illum degenero thema ciminatio conservo.',
    name: 'Toast',
    trigger: {
      scheduleOption: {
        date: new Date('2025-02-04T23:26:25.585Z'),
        exclusionDates: [new Date('2025-02-15T12:43:01.072Z')],
        timeSlot: {
          endDate: new Date('2025-08-05T14:03:10.496Z'),
          startDate: new Date('2024-12-10T01:25:00.788Z'),
        },
      },
      type: 'AUTOMATIC',
    },
    creationDate: new Date('2025-01-05T02:42:22.664Z'),
    id: '1c8ef08b-6aa5-4fc0-984a-a89f01044803',
    status: 'SCHEDULED',
    statusDetail: {
      errorCode: '123',
      message: 'Curis bellum cursus ager occaecati spectaculum damno omnis cur.',
      placeholders: [
        {
          key: '123',
          value: 'Lorem',
        },
      ],
    },
    creator: {
      id: '1d8c8bc5-301f-4608-8573-36a7ca98f1ae',
      name: 'Rogelio Padberg',
      type: 'AUTOMATOR',
    },
    dynamicGroup: {
      deviceCount: 1,
      query: {
        filters: [
          {
            filterType: 'string',
            name: 'entity.attribute',
            operator: 'equals',
            value: 'comis aliqua',
          },
        ],
        sort: {
          field: 'entity.attribute',
          order: 'DESC',
        },
      },
      reference: {
        id: '6850d10f-5f1d-4b70-83dc-08ed0b0bd437',
        description: 'Curriculum curriculum varius.',
        name: 'Ergonomic Bronze Chicken',
      },
      snapshotId: '958a6f43-64c3-4de8-8139-c06595ece3f6',
      type: 'CUSTOM',
    },
    options: {
      configuration: {
        custom: {
          definition: {
            compositions: [
              {
                configurationId: '6f76a660-5421-4a45-95a3-5916e09f99fc',
                name: 'Mocked Config',
              },
            ],
            configuration: {
              applicationVersions: [
                {
                  id: 'fb3deb79-91a5-4204-ad69-5a52cd76bf5c',
                  order: 123,
                  type: 'CONFIGURATION_MODULE',
                  applicationId: '6f76a660-5421-4a45-95a3-5916e09f99fc',
                  applicationLogo: {
                    id: '6ece63c4-6bd4-4682-9102-7ec18bae014e',
                    type: 'IMAGE',
                  },
                  applicationVersions: [],
                  applicationVersionStatus: 'PUBLISHED',
                  applicationStatus: 'PUBLISHED',
                  applicationName: 'name',
                  applicationVersionId: '6ece63c4-6bd4-4682-9102-7ec18bae014e',
                  applicationVersionNumber: '1.0.0',
                  configurationModuleName: 'name',
                },
              ],
              osVersion: {
                id: '6ece63c4-6bd4-4682-9102-7ec18bae014e',
                osVersionStatus: 'PUBLISHED',
                osStatus: 'PUBLISHED',
                osVersions: [],
                osId: '6ece63c4-6bd4-4682-9102-7ec18bae014e',
                osLogo: {
                  id: '6ece63c4-6bd4-4682-9102-7ec18bae014e',
                  type: 'IMAGE',
                },
                osName: 'os name',
                osVersionId: '6ece63c4-6bd4-4682-9102-7ec18bae014e',
                osVersionNumber: '1.0.0',
              },
              remoteKeyInjection: ['6ece63c4-6bd4-4682-9102-7ec18bae014e'],
              systemPackageVersions: [
                {
                  id: 'deb908cf-5a3d-4562-b29e-b53c20942666',
                  order: 123,
                  type: 'CONFIGURATION_MODULE',
                  configurationModuleName: 'name',
                  systemPackageId: '6ece63c4-6bd4-4682-9102-7ec18bae014e',
                  systemPackageLogo: {
                    id: '6ece63c4-6bd4-4682-9102-7ec18bae014e',
                    type: 'IMAGE',
                  },
                  systemPackageVersions: [],
                  systemPackageVersionStatus: 'PUBLISHED',
                  systemPackageStatus: 'PUBLISHED',
                  systemPackageName: 'name',
                  systemPackageVersionId: '6ece63c4-6bd4-4682-9102-7ec18bae014e',
                  systemPackageVersionNumber: '1.0.0',
                },
              ],
            },
          },
          description: 'Depraedor verecundia contigo sunt.',
          name: 'AE78ZHuvuAQORKLfy3gf46Cd7yC9mIbXjeREnCYUPZeMFXwd2nJhWTFcffTjLxBg5HL60mgnLvWmAgkGFH5AOF1rnX3ZY18FnNnQ',
          creationDate: new Date('2025-01-23T17:55:06.463Z'),
          creator: {
            id: '26f6a367-db70-48ce-9f35-626db834bd25',
            name: 'Adrian',
          },
          id: '494fb341-1c46-4758-bbb8-e0e0ad6230c3',
          updateDate: new Date('2024-06-22T06:55:45.260Z'),
          updatedBy: {
            id: '26f6a367-db70-48ce-9f35-626db834bd25',
            name: 'Luiz',
          },
        },
        reference: {
          id: '730799d2-3f07-46ad-bc45-642b1607a7f6',
          description: 'Considero triumphus nisi commemoro tamisium viriliter sequi odit antea conculco.',
          name: 'Soft Metal Chicken',
        },
        snapshotId: 'fb618839-324a-4353-a556-a6488eea9be4',
        type: 'CUSTOM',
      },
    },
  };
}

// eslint-disable-next-line max-lines-per-function
export function searchDeploymentUnitsMocks(): DeploymentUnitResourceListResponseV2Api {
  return {
    pagination: {
      itemsPerPage: 100,
      startIndex: 0,
      totalResults: 10,
    },
    data: [
      {
        creationDate: new Date('2021-01-01T00:00:00Z'),
        deploymentRequestId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05801',
        description: 'string',
        deviceId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05801',
        endDate: new Date('2021-01-01T00:00:00Z'),
        id: 'd0e8e8e0-1b4d-4336-99b8-548e08b05801',
        name: '5bBGQg68uB8xQXR279Mh1qZwHMIW1js-yiPNGWMMhfmYdU9MQTODZMMC9F3MbUSN8E.X2LSxGgqVfHwxvl9a4ViH8PldLPQS1DN8Jjp',
        startDate: new Date('2021-01-01T00:00:00Z'),
        status: 'SCHEDULED',
        statusDetail: {
          errorCode: '123',
          message: 'Curis bellum cursus ager occaecati spectaculum damno omnis cur.',
          placeholders: [
            {
              key: '123',
              value: 'Lorem',
            },
          ],
        },
        options: {
          configuration: {
            custom: {
              definition: {
                compositions: [
                  {
                    configurationId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05801',
                  },
                ],
                configuration: {
                  applicationVersions: [
                    {
                      id: 'd0e8e8e0-1b4d-4336-99b8-548e08b05801',
                      order: 100,
                      type: 'CONFIGURATION_MODULE',
                    },
                  ],
                  osVersion: {
                    id: 'd0e8e8e0-1b4d-4336-99b8-548e08b05801',
                  },
                  remoteKeyInjection: ['d0e8e8e0-1b4d-4336-99b8-548e08b05801'],
                  systemPackageVersions: [
                    {
                      id: 'd0e8e8e0-1b4d-4336-99b8-548e08b05801',
                      order: 100,
                      type: 'CONFIGURATION_MODULE',
                    },
                  ],
                },
              },
              description: 'string',
              name: 'Tm',
            },
            reference: {
              id: 'd0e8e8e0-1b4d-4336-99b8-548e08b05801',
            },
            snapshotId: 'd0e8e8e0-1b4d-4336-99b8-548e08b05801',
            type: 'CUSTOM',
          },
        },
      },
    ],
  };
}
